(() => {
  const track = (name, product) => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, { product_name: product.title.split(' - ')[0] });
    }
  };

  const formatPrice = (cents, data) => {
    if (typeof window.Shopify?.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, data.moneyFormat).replace(/([.,]00)(?=\D*$)/, '');
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style: 'currency', currency: data.currency,
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2
    }).format(cents / 100);
  };

  function initializeVariants(root, data) {
    const master = root.querySelector('#productSelect');
    if (!master) return;
    const swatches = Array.from(root.querySelectorAll('.swatch'));
    const galleries = Array.from(root.querySelectorAll('.imgSect'));
    const colourIndex = data.product.options.findIndex(name => /^(color|colour)$/i.test(name));
    let currentVariantId = String(master.value);

    const showColour = variant => {
      const colour = colourIndex === -1 ? '' : variant?.options[colourIndex];
      const selected = galleries.find(gallery => gallery.dataset.colour === colour) || galleries[0];
      galleries.forEach(gallery => { gallery.style.display = gallery === selected ? 'block' : 'none'; });
    };

    const syncSwatches = variant => {
      swatches.forEach(swatch => {
        const index = Number(swatch.dataset.optionIndex);
        swatch.querySelectorAll('.swatch-element').forEach(element => {
          const input = element.querySelector('input');
          const selected = variant ? element.dataset.value === variant.options[index] : input?.checked;
          element.classList.toggle('active', Boolean(selected));
          if (input && variant) input.checked = Boolean(selected);
        });
        const display = swatch.querySelector('.js-swatch-display');
        if (display && variant) display.textContent = variant.options[index];
      });
    };

    const applyVariant = variant => {
      const addButton = root.querySelector('#AddToCart');
      const addLabel = root.querySelector('#AddToCartText');
      if (addButton) {
        addButton.disabled = !variant?.available;
        addButton.classList.toggle('disabled', !variant?.available);
      }
      if (addLabel) addLabel.textContent = variant ? (variant.available ? data.labels.addToCart : data.labels.soldOut) : data.labels.unavailable;
      syncSwatches(variant);
      if (!variant) return;
      showColour(variant);
      master.value = variant.id;
      if (currentVariantId === String(variant.id)) return;
      currentVariantId = String(variant.id);
      const price = root.querySelector('#product-price');
      const compare = root.querySelector('#compare-price');
      const savings = root.querySelector('#savings-badge');
      if (price) price.innerHTML = formatPrice(variant.price, data);
      const onSale = variant.compare_at_price > variant.price;
      if (compare) {
        compare.style.display = onSale ? 'inline-block' : 'none';
        if (onSale) compare.innerHTML = formatPrice(variant.compare_at_price, data);
      }
      if (savings) {
        savings.style.display = onSale ? 'inline-block' : 'none';
        if (onSale) savings.textContent = `save ${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%`;
      }
      const timer = root.querySelector('#sale-timer-block');
      if (timer) timer.style.display = onSale ? '' : 'none';
    };

    root.addEventListener('change', event => {
      if (event.target === master) {
        applyVariant(data.product.variants.find(variant => String(variant.id) === master.value));
        return;
      }
      if (!event.target.matches('.swatchItem')) return;
      const previous = data.product.variants.find(variant => String(variant.id) === currentVariantId);
      const options = data.product.options.map((name, index) => {
        const swatch = swatches.find(element => Number(element.dataset.optionIndex) === index);
        return swatch?.querySelector('input:checked')?.value || previous?.options[index];
      });
      applyVariant(data.product.variants.find(variant => variant.options.every((value, index) => value === options[index])));
    });

    applyVariant(data.product.variants.find(variant => String(variant.id) === currentVariantId));

    const initializeLegacySelectors = () => {
      if (!window.Shopify?.OptionSelectors || !window.jQuery) return;
      new window.Shopify.OptionSelectors(master.id, {
        product: data.product,
        onVariantSelected(variant, selector) {
          if (typeof window.vela?.productPage === 'function') {
            window.vela.productPage({ money_format: data.moneyFormat, variant, selector });
          }
          applyVariant(variant);
        },
        enableHistoryState: true
      });
      if (data.product.available && data.product.options.length > 1 && (!window.swatch_show_unvailable || window.swatch_enable)) {
        window.Shopify.linkOptionSelectors(data.product);
      }
      if (data.product.options.length === 1 && data.product.options[0] !== 'Title') {
        const wrapper = root.querySelector('.selector-wrapper');
        if (wrapper && !wrapper.querySelector('label')) {
          const label = document.createElement('label');
          label.htmlFor = `${master.id}-option-0`;
          label.textContent = data.product.options[0];
          wrapper.prepend(label);
        }
      }
      if (data.product.variants.length === 1 && data.product.variants[0].title.includes('Default')) {
        root.querySelectorAll('.selector-wrapper, .swatch').forEach(element => { element.style.display = 'none'; });
      }
    };
    if (document.readyState === 'complete') initializeLegacySelectors();
    else window.addEventListener('load', initializeLegacySelectors, { once: true });
  }

  function initializeGallery(root, data) {
    const overlay = root.querySelector('[data-cncsit-gallery-overlay]');
    if (!overlay) return;
    const slider = overlay.querySelector('.slider-img');
    const closeButton = overlay.querySelector('.close-btn');
    const previousButton = overlay.querySelector('.prev-btn');
    const nextButton = overlay.querySelector('.next-btn');
    let images = [], index = 0, previousOverflow = '', tracked = false;
    const showImage = () => {
      if (!images[index]) return;
      slider.src = images[index].src;
      slider.alt = images[index].alt;
    };
    const close = () => {
      overlay.classList.remove('active');
      document.body.style.overflow = previousOverflow;
    };
    root.addEventListener('click', event => {
      const image = event.target.closest?.('.imgSect .img img');
      if (!image || !root.contains(image)) return;
      images = Array.from(image.closest('.imgSect').querySelectorAll('.img img'))
        .filter(item => !item.src.includes('transparent-pr'));
      index = images.indexOf(image);
      if (index === -1) return;
      showImage();
      previousOverflow = document.body.style.overflow;
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (!tracked) {
        const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
          || (window.matchMedia('(max-width: 768px)').matches && window.matchMedia('(pointer: coarse)').matches);
        track(mobile ? 'm_imagSliderEvent' : 'imagSliderEvent', data.product);
        tracked = true;
      }
    });
    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', event => { if (event.target === overlay) close(); });
    [[previousButton, -1], [nextButton, 1]].forEach(([button, direction]) => {
      button.addEventListener('click', event => {
        event.stopPropagation();
        if (!images.length) return;
        index = (index + direction + images.length) % images.length;
        showImage();
      });
    });
  }

  function initializeContent(root, data) {
    root.querySelectorAll('.accordion').forEach(accordion => {
      accordion.addEventListener('click', () => {
        accordion.classList.toggle('active');
        const panel = accordion.nextElementSibling;
        const open = panel.classList.toggle('open');
        panel.style.maxHeight = open ? `${panel.scrollHeight + 50}px` : '';
      });
    });
    const guide = root.querySelector('#szOver');
    const guideButton = root.querySelector('.szGuide');
    if (guide && guideButton) {
      guideButton.addEventListener('click', () => {
        guide.style.display = 'flex';
        track('sizeGuideClicked', data.product);
      });
      guide.addEventListener('click', event => {
        if (event.target === guide || event.target.closest('.cls')) guide.style.display = 'none';
      });
    }
    root.addEventListener('click', event => {
      const link = event.target.closest?.('.cncsit-review-link');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const reviews = root.closest('#pageContent')?.querySelector('#product-reviews');
      if (!reviews) return;
      event.preventDefault();
      const header = document.getElementById('velaHeader');
      reviews.style.scrollMarginTop = `${(header?.getBoundingClientRect().height || 0) + 24}px`;
      reviews.focus({ preventScroll: true });
      reviews.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      if (window.location.hash !== link.hash) window.history.pushState(window.history.state, '', link.hash);
    });
    const countdown = root.querySelector('#cdowntimer');
    const end = data.saleEnd ? new Date(data.saleEnd).getTime() : NaN;
    if (!countdown || !Number.isFinite(end)) return;
    let timer;
    const update = () => {
      const distance = end - Date.now();
      if (distance <= 0) {
        countdown.textContent = 'The event has started!';
        window.clearInterval(timer);
        return;
      }
      const days = Math.floor(distance / 86400000);
      const hours = Math.floor(distance % 86400000 / 3600000);
      const minutes = Math.floor(distance % 3600000 / 60000);
      const seconds = Math.floor(distance % 60000 / 1000);
      countdown.textContent = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    };
    update();
    if (end > Date.now()) timer = window.setInterval(update, 1000);
  }

  function initializeUpsells(root, data) {
    const error = root.querySelector('.cncsit-upsell-error');
    data.upsells.forEach(config => {
      const card = root.querySelector(`#${config.container}`);
      if (!card) return;
      const selector = card.querySelector('.szSelection select');
      const image = card.querySelector('img');
      const button = card.querySelector('.addToCrt');
      const findVariant = title => config.variants.find(variant => variant.title === title)
        || config.variants.find(variant => title && variant.title.includes(title));
      const initial = findVariant(config.defaultVariant) || config.variants.find(variant => variant.available) || config.variants[0];
      if (initial) selector.value = initial.title;
      let selected;
      const update = () => {
        selected = findVariant(selector.value);
        button.textContent = selected?.available ? data.labels.addToCart : data.labels.soldOut;
        button.classList.toggle('notActive', !selected?.available);
        button.setAttribute('aria-disabled', String(!selected?.available));
      };
      update();
      const firstImage = config.firstImage || image.getAttribute('src');
      const secondImage = config.hoverImage || firstImage;
      if (firstImage) image.src = firstImage;
      if (firstImage && secondImage !== firstImage) {
        image.addEventListener('mouseenter', () => { image.src = secondImage; });
        image.addEventListener('mouseleave', () => { image.src = firstImage; });
      }
      image.addEventListener('click', () => { window.location.href = config.url; });
      selector.addEventListener('change', () => {
        update();
        track('upsellOptionChange', data.product);
      });
      button.addEventListener('click', async () => {
        if (!selected?.available || button.dataset.pending) return;
        button.dataset.pending = 'true';
        if (error) error.hidden = true;
        try {
          const response = await window.fetch(data.cartAddUrl, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: selected.id, quantity: 1 }] })
          });
          if (!response.ok) throw new Error(data.labels.cartError);
          const cartResponse = await window.fetch(data.cartUrl);
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            const count = document.getElementById('CartCount');
            if (count) count.textContent = cart.item_count;
          }
        } catch {
          if (error) { error.textContent = data.labels.cartError; error.hidden = false; }
        } finally {
          delete button.dataset.pending;
        }
      });
    });
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-cncsit-product]').forEach(root => {
      if (root.dataset.cncsitInitialized) return;
      const element = root.querySelector('[data-cncsit-product-data]');
      if (!element) return;
      const data = JSON.parse(element.textContent);
      root.dataset.cncsitInitialized = 'true';
      initializeVariants(root, data);
      initializeGallery(root, data);
      initializeContent(root, data);
      initializeUpsells(root, data);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
